/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Calendar_No_BookingsInputs */

const en_seller_calendar_no_bookings = /** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No confirmed rental bookings yet.`)
};

const es_seller_calendar_no_bookings = /** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay reservas confirmadas aún.`)
};

const fr_seller_calendar_no_bookings = /** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune réservation de location confirmée pour le moment.`)
};

const de_seller_calendar_no_bookings = /** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine bestätigten Mietbuchungen.`)
};

const id_seller_calendar_no_bookings = /** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pemesanan sewa yang dikonfirmasi.`)
};

/** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */
const ja_seller_calendar_no_bookings = en_seller_calendar_no_bookings;

/** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */
const zh_seller_calendar_no_bookings = en_seller_calendar_no_bookings;

/** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */
const ar_seller_calendar_no_bookings = en_seller_calendar_no_bookings;

/** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */
const it_seller_calendar_no_bookings = en_seller_calendar_no_bookings;

/** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */
const ru_seller_calendar_no_bookings = en_seller_calendar_no_bookings;

/** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */
const pt_seller_calendar_no_bookings = en_seller_calendar_no_bookings;

/** @type {(inputs: Seller_Calendar_No_BookingsInputs) => LocalizedString} */
const ko_seller_calendar_no_bookings = en_seller_calendar_no_bookings;

/**
* | output |
* | --- |
* | "No confirmed rental bookings yet." |
*
* @param {Seller_Calendar_No_BookingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_calendar_no_bookings = /** @type {((inputs?: Seller_Calendar_No_BookingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Calendar_No_BookingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_calendar_no_bookings(inputs)
	if (locale === "es") return es_seller_calendar_no_bookings(inputs)
	if (locale === "fr") return fr_seller_calendar_no_bookings(inputs)
	if (locale === "de") return de_seller_calendar_no_bookings(inputs)
	if (locale === "ja") return ja_seller_calendar_no_bookings(inputs)
	if (locale === "zh") return zh_seller_calendar_no_bookings(inputs)
	if (locale === "ar") return ar_seller_calendar_no_bookings(inputs)
	if (locale === "id") return id_seller_calendar_no_bookings(inputs)
	if (locale === "it") return it_seller_calendar_no_bookings(inputs)
	if (locale === "ru") return ru_seller_calendar_no_bookings(inputs)
	if (locale === "pt") return pt_seller_calendar_no_bookings(inputs)
	return ko_seller_calendar_no_bookings(inputs)
});